module.exports = __webpack_public_path__ + "static/media/univar_interno.93aa01ec.png";